export default {
    LOAD_SCHEDULE_LIST_SUCCESS: "LOAD_SCHEDULE_LIST_SUCCESS",
    DELETE_SCHEDULE_SUCCESS: "DELETE_SCHEDULE_SUCCESS",
    ADD_SCHEDULE_SUCCESS: "ADD_SCHEDULE_SUCCESS",
};